import React, { useEffect, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
const LearnerAuth: React.FC = () => {
  // Form state
  const [signupEmail, setSignupEmail] = useState('');
  const [signupPassword, setSignupPassword] = useState('');
  const [signupFullName, setSignupFullName] = useState('');
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  // User state
  const [user, setUser] = useState<any>(null);
  const [userFullName, setUserFullName] = useState('');
  const [showDashboard, setShowDashboard] = useState(false);
  const [loading, setLoading] = useState(true);
  // Handle signup
  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const {
        data,
        error
      } = await supabase.auth.signUp({
        email: signupEmail,
        password: signupPassword
      });
      if (error) {
        alert('Error signing up: ' + error.message);
        return;
      }
      // Once signed up, update profile with full_name
      if (data.user) {
        await supabase.from('profiles').upsert({
          id: data.user.id,
          full_name: signupFullName,
          created_at: new Date().toISOString()
        });
      }
      alert('Signup successful! Check your email to confirm your account.');
      // Reset form
      setSignupEmail('');
      setSignupPassword('');
      setSignupFullName('');
    } catch (error) {
      console.error('Error during signup:', error);
      alert('An unexpected error occurred during signup.');
    }
  };
  // Handle login
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const {
        data,
        error
      } = await supabase.auth.signInWithPassword({
        email: loginEmail,
        password: loginPassword
      });
      if (error) {
        alert('Login failed: ' + error.message);
        return;
      }
      // Reset form
      setLoginEmail('');
      setLoginPassword('');
    } catch (error) {
      console.error('Error during login:', error);
      alert('An unexpected error occurred during login.');
    }
  };
  // Handle logout
  const handleLogout = async () => {
    await supabase.auth.signOut();
  };
  // Load user profile
  const loadUserProfile = async (userId: string) => {
    try {
      const {
        data,
        error
      } = await supabase.from('profiles').select('full_name').eq('id', userId).single();
      if (error && error.code !== 'PGRST116') {
        console.error('Error fetching profile:', error);
        return;
      }
      setUserFullName(data?.full_name || 'Not set');
    } catch (error) {
      console.error('Error loading profile:', error);
    }
  };
  // Check auth state on component mount and listen for changes
  useEffect(() => {
    // Get initial session
    const checkSession = async () => {
      const {
        data: {
          session
        }
      } = await supabase.auth.getSession();
      setUser(session?.user || null);
      setShowDashboard(!!session?.user);
      if (session?.user) {
        await loadUserProfile(session.user.id);
      }
      setLoading(false);
    };
    checkSession();
    // Set up auth state change listener
    const {
      data: {
        subscription
      }
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      setUser(session?.user || null);
      setShowDashboard(!!session?.user);
      if (session?.user) {
        await loadUserProfile(session.user.id);
      }
    });
    // Clean up subscription on unmount
    return () => {
      subscription.unsubscribe();
    };
  }, []);
  if (loading) {
    return <div data-id="element-35">Loading...</div>;
  }
  return <div style={{
    fontFamily: 'sans-serif',
    maxWidth: '500px',
    margin: 'auto',
    padding: '20px'
  }} data-id="element-36">
      <h1 data-id="element-37">Learner Signup / Login</h1>
      {!showDashboard ? <>
          {/* Sign Up Form */}
          <form onSubmit={handleSignup} style={{
        marginBottom: '20px'
      }} data-id="element-38">
            <h3 data-id="element-39">Sign Up</h3>
            <input type="email" placeholder="Email" value={signupEmail} onChange={e => setSignupEmail(e.target.value)} required style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-40" />
            <input type="password" placeholder="Password" value={signupPassword} onChange={e => setSignupPassword(e.target.value)} required style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-41" />
            <input type="text" placeholder="Full Name" value={signupFullName} onChange={e => setSignupFullName(e.target.value)} required style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-42" />
            <button type="submit" style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-43">
              Create Account
            </button>
          </form>
          {/* Login Form */}
          <form onSubmit={handleLogin} style={{
        marginBottom: '20px'
      }} data-id="element-44">
            <h3 data-id="element-45">Login</h3>
            <input type="email" placeholder="Email" value={loginEmail} onChange={e => setLoginEmail(e.target.value)} required style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-46" />
            <input type="password" placeholder="Password" value={loginPassword} onChange={e => setLoginPassword(e.target.value)} required style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-47" />
            <button type="submit" style={{
          display: 'block',
          width: '100%',
          margin: '8px 0',
          padding: '10px'
        }} data-id="element-48">
              Login
            </button>
          </form>
        </> /* Learner Dashboard */ : <div style={{
      border: '1px solid #ddd',
      padding: '20px',
      borderRadius: '8px'
    }} data-id="element-49">
          <h2 data-id="element-50">
            Welcome, <span data-id="element-51">{user?.email}</span>
          </h2>
          <p data-id="element-52">
            Full Name: <span data-id="element-53">{userFullName}</span>
          </p>
          <button onClick={handleLogout} style={{
        display: 'block',
        width: '100%',
        margin: '8px 0',
        padding: '10px'
      }} data-id="element-54">
            Logout
          </button>
        </div>}
    </div>;
};
export default LearnerAuth;